import styles from './PackageCard.module.css';
import activeIcon from '../../shared/Product/assets/icon.svg';

// Package card component to display a single paint package
export default function PackageCard({ package: pkg, isSelected, onSelect }) {
    const cardClassName = isSelected 
        ? `${styles.packageCard} ${styles.packageCardSelected}` 
        : styles.packageCard;
    
    // Generate background style from product ID
    const getBackgroundStyle = (productId) => {
        if (!productId) return {};
        const url = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(!${productId})&type=prod&extra=(focus=300)&Size=100`;
        return { backgroundImage: `url("${encodeURI(url)}")` };
    };

    // Color data with numbers matching the visual layout
    const colors = [
        { num: 1, label: 'Body', name: pkg.body, productId: pkg.bodyProductId },
        { num: 2, label: 'Secondary Body', name: pkg.secondaryBody, productId: pkg.secondaryProductId },
        { num: 3, label: 'Trim', name: pkg.trim, productId: pkg.trimProductId }
    ];

    return (
        <div className={cardClassName} onClick={() => onSelect(pkg)}>
            {/* Visual color block layout */}
            <div className={styles.colorBlocksContainer}>
                {isSelected && <img className={styles.selectedIcon} src={activeIcon} alt="Selected" />}
                <div className={styles.leftSection}>
                     <div 
                        className={styles.colorBlock} 
                        style={getBackgroundStyle(pkg.bodyProductId)}
                    >
                        <span className={styles.colorNumber}>1</span>
                    </div>
                    <div 
                        className={styles.colorBlock} 
                        style={getBackgroundStyle(pkg.secondaryProductId)}
                    >
                        <span className={styles.colorNumber}>2</span>
                    </div>
                    <div 
                        className={styles.colorBlock} 
                        style={getBackgroundStyle(pkg.trimProductId)}
                    >
                        <span className={styles.colorNumber}>3</span>
                    </div>
                </div>
            </div>

            {/* Scheme title and color list */}
            <div className={styles.packageInfo}>
                <h3 className={styles.schemeTitle}>Scheme {pkg.schemeNumber}</h3>
                <ul className={styles.colorList}>
                    {colors.map((color) => (
                        <li key={color.num} className={styles.colorItem}>
                            <p className={styles.colorItemText}>{color.num} - {color.label}: {color.name}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
